<app-email-details-form [initialData]="initialData" testIdPrefix="wizard-"></app-email-details-form>
